import { FC, useState, createRef } from "react";
import { LdButton, LdTypo } from "@emdgroup-liquid/liquid/dist/react";

import TagInput from "components/TagInput";

interface Props {
  users?: string[];
  onSubmit: (arg0: string[]) => void;
  onCancel: () => void;
}

const AddUserForm: FC<Props> = ({
  users: initialUsers = [],
  onCancel,
  onSubmit,
}) => {
  const formRef = createRef<HTMLFormElement>();
  const [users, setUsers] = useState(initialUsers);
  const handleSubmit = () => {
    onSubmit(users);
    // if (formRef.current?.onsubmit !== null) {
    //   formRef.current?.onsubmit(new SubmitEvent("submit"));
    // }
  };

  return (
    <div className="flex flex-col gap-8">
      <LdTypo variant="h2">Invite Participants</LdTypo>
      <TagInput
        ref={formRef}
        label={users.length ? "Already invited" : null}
        tags={users}
        placeholder="j.doe@merckgroup.com"
        onChange={setUsers}
      />
      <div className="flex gap-8 justify-end">
        <LdButton onClick={onCancel} mode="secondary">
          Cancel
        </LdButton>
        <LdButton onClick={handleSubmit}>Save</LdButton>
      </div>
    </div>
  );
};

export default AddUserForm;
